import React, { useState, useEffect } from 'react';
import { useDebounce } from "use-debounce";
import LeadComponent from "../components/smart/LeadComponent";
import LeadFilterForm from "../forms/LeadFilterForm";

function LeadPage() {
  const [filter, setFilter] = useState({ name: undefined, email: undefined, phoneNo: undefined, leadStage: undefined,
    assignedTo: undefined, 'dateAddedStart': 1633060315});
  const [debouncedFilter, setDebouncedFilter] = useDebounce(filter, 1000);

  useEffect(() => {
    document.title = 'View Leads'
  })


  return (
    <div>
      <h3 className="ml-0 mr-0 mx-auto text-center"> Lead Page </h3>
      <div className="row" style={{ marginTop: '5%', marginRight: '250px' }}>
        <div className="col-lg-2">
          <LeadFilterForm changeFilter={(name, email, phoneNo, leadStage, assignedTo, dateAddedStart, targetBatch) => setFilter({ name, email, phoneNo,
            leadStage, assignedTo, dateAddedStart, targetBatch })} />
        </div>
        <div className="col-lg-6">
          <LeadComponent filter={debouncedFilter} />
        </div>
      </div>
    </div>
  )
}

export default LeadPage;
